<template>
  <van-dialog
    v-model="show"
    :show-confirm-button="false"
    width="764px"
    style="border-radius: 3px;"
    :overlay-style="{width:'100vw'}"
    @confirm="onConfirmCustomer"
    @cancel="cancel"
  >
    <span slot="title" class="dialog_title">{{
      !showCancel ? '切换门店' : '选择门店'
    }}</span>
    <van-list
      v-model="loading"
      :finished="true"
      finished-text=""
      style="height:324px;overflow:auto"
      class="scrollWrapper"
    >
      <div
        v-for="item in dataList"
        :key="item.Id"
        class="storelist"
        :class="{ checked: item.checked }"
        @click="changeCheckbox(item)"
      >
        <div class="title">{{ item.CustomerName }}</div>
        <div class="address">
          {{ item.AreaName }} {{ setStreet(item.Address, item.AreaName) }}
        </div>
      </div>
    </van-list>
    <div class="van-dialog__footer">
      <van-button v-if="!showCancel" @click="cancel">取消</van-button>
      <van-button
        color="#0F6EEA"
        :disabled="!selected"
        @click="onConfirmCustomer()"
      >确定</van-button>
    </div>
  </van-dialog>
</template>
<script>
import { LinkTypeCode } from '../dictionary/base'
export default {
  name: 'SwitchStore',
  props: ['showCancel'],
  data() {
    return {
      show: false,
      dataList: [],
      loading: true,
      selected: null,
      url: {
        customers: '/api_customers/Customer/GetByContact',
        selectCustomer: '/clientapi_contacts/Contacts/SelectCustomer'
      }
    }
  },
  methods: {
    Show(customers) {
      this.show = true
      this.selected = null
      if (customers && customers.length > 0) {
        customers.forEach((w) => {
          w.checked = false
          if (this.auth.getCustomerId() && w.Id == this.auth.getCustomerId()) {
            w.checked = true
            this.selected = w
          }
        })
        if (!this.selected) {
          customers[0].checked = true
          this.selected = customers[0]
        }
        this.dataList = customers
      } else {
        this.loadStore()
      }
    },
    // 加载店铺数据
    async loadStore() {
      this.$hys.openLoading()
      const res = await this.getAction(this.url.customers)
      this.$hys.clearLoading()
      if (!res.IsSuccess) {
        this.$toast({ position: 'bottom', message: res.Msg })
        return
      }
      res.Data.forEach((w) => {
        w.checked = false
        if (this.auth.getCustomerId() && w.Id == this.auth.getCustomerId()) {
          w.checked = true
          this.selected = w
        }
      })
      const customers = res.Data
      if (!customers || customers.length == 0) {
        this.$toast({
          position: 'bottom',
          message: this.lang.Login.ErrorCustomerTip
        })
        return
      }
      if (customers.length == 1 && this.isFromLogin) {
        this.selected = customers[0]
        await this.onConfirmCustomer()
        return
      }
      this.dataList = customers
    },
    changeCheckbox(item) {
      this.dataList.forEach((tag) => {
        tag.checked = tag.Id == item.Id
      })
      this.selected = item
      this.$forceUpdate()
    },
    // 确定数据选择
    async onConfirmCustomer(customer) {
      if (!customer) {
        if (!this.selected) {
          this.$toast({
            position: 'bottom',
            message: this.lang.Login.ErrorCustomerTip
          })
          return false
        } else {
          customer = this.selected
        }
      }
      this.$hys.openLoading()
      const res = await this.getAction(this.url.selectCustomer, {
        customerid: customer.Id
      })

      this.$hys.clearLoading()
      if (!res.IsSuccess) {
        this.$toast({ position: 'bottom', message: res.Msg })
        return
      }
      this.auth.setServiceData(JSON.stringify({
        '门店名称': customer.CustomerName,
        '门店类型': customer.CustomerTypeText,
        '注册地址': customer.Address
      }))
      this.auth.setCustomerId(customer.Id)
      this.auth.setCustomerName(customer.CustomerName)
      this.auth.setContactsId(customer.ContactsId)
      this.auth.setCustomerType(customer.CustomerType)
      this.show = false
      // 只能回到首页
      this.$emit('confirm', customer)
    },
    setStreet(address, areaName) {
      if (address && areaName && address.indexOf(areaName) != -1) {
        return address.substring(
          address.indexOf(areaName) + areaName.length,
          address.length
        )
      } else {
        return address
      }
    },
    cancel() {
      this.$emit('cancel')
      this.show = false
    }
  }
}
</script>
<style lang="less" scoped>
.storelist {
  box-sizing: border-box;
  margin-top: 20px;
  margin-left: 50px;
  margin-right: 50px;
  text-align: left;
  padding: 11px 0 0 15px;
  cursor: pointer;
  height: 88px;

  background: rgba(255, 255, 255, 1);
  border-radius: 1px;
  border: 1px solid rgba(229, 229, 229, 1);

  .title {
    font-size: 18px;
    font-weight: 600;
    color: rgba(34, 34, 34, 1);
  }

  .address {
    font-size: 16px;
    color: rgba(34, 34, 34, 1);
    line-height: 22px;
  }
}

.dialog_title {
  font-weight: 600;
}

.checked {
  box-shadow: 0px 2px 10px 0px rgba(234, 234, 234, 1);
  border: 2px solid rgba(15, 110, 234, 1);
}

.van-dialog__footer {
  margin-top: 12px;
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;

  button {
    width: 140px;
    height: 50px;
    box-sizing: border-box;
    font-size: 16px;

    &:first-child {
      background: rgba(255, 255, 255, 1);
      border-radius: 2px;
      border: 1px solid rgba(229, 229, 229, 1);
      color: #999999;
    }

    &:last-child {
      margin-left: 20px;
      background: rgba(15, 110, 234, 1);
      border-radius: 2px;
      color: #ffffff;
    }

    &::before {
      width: 140px;
      height: 50px;
    }

    &::after {
      width: 140px;
      height: 50px;
    }
  }
}

.scrollWrapper {
  max-height: 400px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 15px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }

  &::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    //border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #e8e8e8;
  }

  &::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    // border-radius: 1px;
    background: #f5f5f5;
  }
}
</style>
